module.exports = __webpack_public_path__ + "static/media/IMG_0807.0fe4a0ad.jpg";